// ---------------------------------------------------------------------------
// DiCharts SDK – Entry Point
// ---------------------------------------------------------------------------
// This file is the entry point for the SDK bundle.
// It exposes the global `DiCharts` object when loaded as an IIFE,
// and named exports when used as an ES module.
// ---------------------------------------------------------------------------

export { createWidget } from './widget';
export { DiChart } from '../../dicharts-lib/dist/index.js';

// Re-export types for TypeScript consumers
export type {
  WidgetConfig,
  DiWidget,
  TickInput,
  DataSource,
  StreamingConfig,
  ToolbarConfig,
  CandleStyle,
  OHLCTuple,
  OverlayConfig,
  SubPaneConfig,
  DiChartInstance,
  IndicatorDef,
  TimeframeInfo,
} from './types';

// Event system
export { EventEmitter } from './events';
export type { WidgetEventMap, WidgetEventName } from './events';

export { INDICATORS, CANDLE_STYLES, TIMEFRAMES } from './types';

// Core lib utilities (from pre-built dist)
export {
  createTickAggregator,
  darkTheme,
  lightTheme,
  computeSMA,
  computeEMA,
  computeBollinger,
  computeRSI,
  computeMACD,
  downsampleOHLC,
  toHeikinAshi,
  toRenko,
} from '../../dicharts-lib/dist/index.js';

// Standalone chart components (from TypeScript source)
export { createDepthChart } from '../../dicharts-lib/src/charts/DepthChart';
export { createHeatmap } from '../../dicharts-lib/src/charts/Heatmap';
export { createSparkline } from '../../dicharts-lib/src/charts/Sparkline';
export { createGauge } from '../../dicharts-lib/src/charts/Gauge';
export { createDonutChart, createDonutChart as createPieChart } from '../../dicharts-lib/src/charts/DonutChart';
export { createBarChart } from '../../dicharts-lib/src/charts/BarChart';
export { createRadarChart } from '../../dicharts-lib/src/charts/RadarChart';
export { createAreaChart } from '../../dicharts-lib/src/charts/AreaChart';
export { createBookmap } from '../../dicharts-lib/src/charts/BookmapChart';
export { createOrderFlow } from '../../dicharts-lib/src/charts/OrderFlowChart';
export { createLiquidationChart } from '../../dicharts-lib/src/charts/LiquidationChart';
export { createDarkPool } from '../../dicharts-lib/src/charts/DarkPoolChart';
export { createGexChart } from '../../dicharts-lib/src/charts/GexChart';
export { createMarketProfile } from '../../dicharts-lib/src/charts/MarketProfileChart';
export { createCumulativeDelta } from '../../dicharts-lib/src/charts/CumulativeDeltaChart';
